// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"096b2ed0","611":"2db27f6c"}[chunkId] + ".css";
};